const all_cross = {
  placeholder: 'Sezione in costruzione',
  steps: {
    kparts: 'K-Parts e Brand',
    data: 'Classi CATI',
    circolante: 'Circolante',
    integration: 'Integrazione',
  },
  kparts_files: 'File KParts',
  kparts_brands: 'Brand KParts',
  date_label: 'Dati',
  groups: 'Selezione gruppi',
  brands: 'Selezione brand Cati',
  classes: 'Selezione classi',
  product_id: 'Product ID',
  cati_code: 'Codice Cati',
  class_code: 'Codice classe',
  supplier_code_1: 'Codice Fornitore 1',
  supplier_code_2: 'Codice Fornitore 2',
  manufacturer_name: 'Produttore',
  dataset_label: 'Dataset',
  dataset_cati: 'CATI',
  dataset_cross: 'Cross',
  dataset_cati_cross: 'CATI+Cross',
  cati_columns_label: 'Seleziona colonne CATI',
  cross_columns_label: 'Seleziona colonne Cross',
  cross: 'Cross',
  circolante_products: 'Circolante AM',
  circolante_reliability: 'Tipo Cross',
  circolante_total: 'Totale cross disponibili',
  brands_include: 'CROSS: Scelta brand da includere',
  brand_cross: 'Brand cross',
  network_view: 'Network View',
  cross_per_brand: 'Cross per brand',
  brand_1: 'Brand',
  brand_2: 'Brand (#1)',
  n_cross: 'n. cross',
  cati_cross_title: 'File cross con codici CATI',
  vio_code: 'VIO CODE',
}

export default all_cross
